import { useParams } from 'react-router-dom';
import QuizForm from '../../components/quiz/QuizForm';
import QuizMarking from '../../components/quiz/QuizMarking';
import Error from '../../components/ui/Error';
import NotFound from '../../components/ui/NotFound';
import { usePageTitle } from '../../hooks/usePageTitle';
import useUserInfo from '../../hooks/useUserInfo';
import QuizLoader from '../../Loader/student/QuizLoader';
import { useGetQuizAndMarkQuery } from '../../redux/features/quiz/quizApi';

export default function QuizPage() {
    usePageTitle(`Quiz`);
    const user = useUserInfo()
    const { videoId } = useParams();
    const { data, isLoading, isError } = useGetQuizAndMarkQuery({ videoId: Number(videoId), studentId: user?.id })


    //  decide what to render
    let content = null;
    if (isLoading) { content = <QuizLoader /> }
    else if (!isLoading && isError) { content = <Error message={"There was an error"} isPadding={true} /> }
    else if (!isLoading && !isError && !data?.quizzes?.length) {
        content = <NotFound message={"No quiz Found"} isPadding={true} />
    }
    else if (!isLoading && !isError && data?.quizzes?.length) {
        content = (
            <section className="py-6 bg-primary">
                <div className="mx-auto max-w-7xl px-5 lg:px-0">
                    <div className="mb-8">
                        <h1 className="text-2xl font-bold">Quizzes for "{data.quizzes[0].video_title}"
                        </h1>
                        <p className="text-sm text-slate-200">Each question contains 5 Mark</p>
                    </div>
                    {data.isQuizMark && <QuizMarking quizMark={data.quizMark} />}
                    <QuizForm quizzes={data.quizzes} isQuizMark={data.isQuizMark} />

                </div>
            </section>)
    }


    return content
};